import React, {PropTypes} from 'react'
import {connect} from 'react-redux'

import Header from './Header'
import { operatorFetch as fetchOrders } from '../../common/orders/actions'
import ConnectionStatus from '../../common/containers/connectionStatus/ConnectionStatus'

let App = React.createClass({

  componentDidMount() {
    if (this.props.orders.length === 0) {
      this.props.dispatch(fetchOrders());
    }
  },

  onlineAgain() {
    this.props.dispatch(fetchOrders());
  },

  render() {
    return (
      <div>
        <ConnectionStatus
          lang={this.props.app.language}
          testUrl={window.location.href}
          onlineAgain={this.onlineAgain}
        />
        <Header location={this.props.location} />
        <section className="content">
          {this.props.children}
        </section>
      </div>
    )
  }
})

let mapStateToProps = state => {
  return {
    app: state.app,
    orders: state.orders.orders
  }
}

export default connect(mapStateToProps)(App)
